import { Footer } from "@/components/Footer";
import { PageMeta } from "@/components/site/blocks";
import { Band, CardGrid, Closing, Hero, JsonLd, P, In } from "@/components/seo/kit";

// /guides: the hub for ClearMakes Inbox guides and set-up pages.
// Plan: gtm/products/clearmakes-inbox/seo/pages/guides.md

const GUIDES = [
  {
    href: "/guides/forward-email-to-slack-channel",
    tag: "Guide",
    title: "How to forward emails to a Slack channel",
    body: "Slack's channel address, Gmail filters, Outlook rules and workflows: the steps for each, and what each one misses.",
  },
  {
    href: "/guides/auto-reply-to-common-customer-questions",
    tag: "Guide and templates",
    title: "How to auto-reply to common customer questions",
    body: "Find the questions you answer every day, write one good answer each, and send them automatically. With 8 templates.",
  },
  {
    href: "/alternatives/zapier",
    tag: "Comparison",
    title: "Zapier alternatives for email and chat",
    body: "Six options with prices we checked, who each suits, and when staying on Zapier makes sense.",
  },
];

const SETUP = [
  { href: "/integrations/gmail-to-slack", tag: "Set-up", title: "Gmail to Slack", body: "Post the Gmail emails that matter to the right Slack channel, with a summary." },
  { href: "/integrations/outlook-to-slack", tag: "Set-up", title: "Outlook to Slack", body: "Post Outlook emails to Slack without a forwarding rule that bounces." },
  { href: "/integrations/outlook-to-teams", tag: "Set-up", title: "Outlook to Teams", body: "Three ways to post Outlook emails to a Teams channel, free ones first." },
  { href: "/integrations/email-to-hubspot", tag: "Set-up", title: "Email leads to HubSpot", body: "Create HubSpot contacts from new enquiries, and draft a reply." },
];

const itemList = {
  "@type": "ItemList",
  name: "ClearMakes Inbox guides",
  itemListElement: [...GUIDES, ...SETUP].map((g, i) => ({ "@type": "ListItem", position: i + 1, name: g.title, url: `https://clearmakes.com${g.href}` })),
};

const Guides = () => (
  <>
    <PageMeta
      title="Email and Chat Automation Guides | ClearMakes Inbox"
      description="Step-by-step guides for email and chat work: forward email to Slack, auto-reply to common questions, post Outlook email to Teams, and Zapier alternatives."
      path="/guides"
    />
    <JsonLd data={itemList} />
    <main>
      <Hero
        eyebrow="Guides"
        title="Guides for email and chat work"
        lead="Plain, step-by-step guides for the jobs that fill an inbox. The free ways come first; where ClearMakes Inbox helps, we say how, and where it doesn't, we say that too."
        primary={null}
        secondary={{ label: "What ClearMakes Inbox does", href: "/products/inbox" }}
      />
      <Band tone="pale" title="Guides and comparisons" answer="Each guide works without our product. Read the steps, try the free way, and come back if you want it done for you.">
        <CardGrid items={GUIDES} />
      </Band>
      <Band tone="white" title="Set-up guides for each pair of apps" answer="These pages show exactly what a workflow between two apps does, the steps to set it up, what it can read, and its limits.">
        <CardGrid items={SETUP} />
        <P>
          See every app Inbox connects to on the <In href="/integrations">integrations page</In>, or read the <In href="/documentation">ClearMakes Inbox documentation</In>.
        </P>
      </Band>
      <Closing title="Want it done for you?" line="Connect your apps, describe the job in one sentence, and check the steps." />
    </main>
    <Footer />
  </>
);

export default Guides;
